// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Z68t","color":"styles_color__EmSs4","sketch":"styles_sketch__CjTfu"};